const NOTE_ROUTE = /^\/note\/[^/]+\/?$/;
const ENCOUNTER_ROUTE = /^\/encounters\/[^/]+\/?$/;

export const isToolbarRoute = (pathname: string): boolean =>
  NOTE_ROUTE.test(pathname) || ENCOUNTER_ROUTE.test(pathname);
